/* eslint-disable jsx-a11y/alt-text */
import first from "../../../assets/images/againnew.png";
import second from "../../../assets/images/newsec.png";
import line from "../../../assets/images/line.png";
import styles from "../seven/seven.module.scss";

const Seven = () => {
  return (
    <>
      <div className={styles.main_wrapper}>
        <div className="container_right">
          <div className={styles.wrapper}>
            <div className={styles.img}>
              <img src={first} />
            </div>

            <div className={styles.text}>
              <span className={styles.new_main}>
                How it works <img src={line} />
              </span>
              <p className={styles.scehdule}>
                Schedule inspections in 2 easy steps
              </p>
              <div className={styles.create_main}>
                <p className={styles.create}>
                  <span>01 .</span> Create Account
                </p>
                <p className={styles.sign}>
                  Sign up and make an account to manage your inspection needs.
                </p>
              </div>
              <div className={styles.create_main}>
                <p className={styles.create}>
                  <span>02 .</span> Schedule Appointment
                </p>
                <p className={styles.sign}>
                  Simply add the property details and schedule an appointment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.main_wrapper}>
        <div className="container_left">
          <div className={`${styles.wrapper} ${styles.wrapper_sec}`}>
            <div className={styles.text}>
              <p className={styles.scehdule}>Manage and Track with ease</p>
              <div className={styles.create_main}>
                <p className={styles.create}>
                  <span>01 .</span> Notification & Updates
                </p>
                <p className={styles.sign}>
                  Get scheduling updates and notifications via App, email or
                  phone
                </p>
              </div>
              <div className={styles.create_main}>
                <p className={styles.create}>
                  <span>02 .</span> Real time tracking
                </p>
                <p className={styles.sign}>
                  See your appointment progress real time.
                </p>
              </div>
              <div className={styles.create_main}>
                <p className={styles.create}>
                  <span>03 .</span> Go Digital
                </p>
                <p className={styles.sign}>
                  Receive your inspection reports digitally..
                </p>
              </div>{" "}
              <div className={styles.create_main}>
                <p className={styles.create}>
                  <span>04 .</span> Convenient record keeping
                </p>
                <p className={styles.sign}>
                  Keep all records digital and in one place for anytime access.
                </p>
              </div>
            </div>

            <div className={styles.img}>
              <img src={second} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Seven;
